import { defineMessages } from "react-intl";

export const scope = "components.DepositPersonalAccountBridge";

export const messages = defineMessages({
  transferOrigin: {
    id: `${scope}.transferOrigin`,
    defaultMessage: "Origen de la transferencia",
  },
  accountToTransfer: {
    id: `${scope}.accountToTransfer`,
    defaultMessage: "Cuenta a transferir",
  },
  copyAll: {
    id: `${scope}.copyAll`,
    defaultMessage: "COPIAR TODO",
  },
  emptyCase: {
    id: `${scope}.emptyCase`,
    defaultMessage:
      "Los datos no pueden ser mostrados en este {br}momento. Por favor contactate con soporte.",
  },
  copy: {
    id: `${scope}.copy`,
    defaultMessage: "COPIAR",
  },
  monthlyDeposits: {
    id: `${scope}.monthlyDeposits`,
    defaultMessage:
      "Todos tus depósitos no podrán superar los { amount } { currency } mensuales.",
  },
  bank_address: {
    id: `${scope}.bank_address`,
    defaultMessage: "Bank Address",
  },
  bank_name: {
    id: `${scope}.bank_name`,
    defaultMessage: "Bank",
  },
  bank_beneficiary_name: {
    id: `${scope}.bank_beneficiary_name`,
    defaultMessage: "Beneficiary",
  },
  account_type: {
    id: `${scope}.account_type`,
    defaultMessage: "Account type",
  },
  bank_account_number: {
    id: `${scope}.bank_account_number`,
    defaultMessage: "Account number",
  },
  bank_routing_number: {
    id: `${scope}.bank_routing_number`,
    defaultMessage: "Routing number",
  },
  notificationMessages: {
    id: `${scope}.notificationMessages`,
    defaultMessage:
      "Para poder depositar, debes aceptar los términos y condiciones primero.",
  },
  notificationTitle: {
    id: `${scope}.notificationTitle`,
    defaultMessage: "Cuenta de dolares",
  },
});
